import * as Actions from "./actions";
import * as ActionTypes from "./actionTypes";
// import { useLocation } from "react-router";
const initialState = {
  loading: false,
  postingResult: {},
  LkRecipientDetails: {},

  LkRecipientHistory: [],
};

const LkRecipient = (state = initialState, action) => {
  if (!action) return state;
  switch (action.type) {
    case ActionTypes.LK_RECIPIENT_HISTORY:
      return { ...state };
    case ActionTypes.LK_RECIPIENT_HISTORY_SUCCESS:
      return {
        ...state,
        LkRecipientHistory: [...action.response],
        loading: true,
      };
    case ActionTypes.LK_RECIPIENT_HISTORY_FAIL:
      return {
        ...state,
        LkRecipientHistory: [],
        loading: true,
      };
    case ActionTypes.LK_RECIPIENT_DETAILS:
      return { ...state, loading: true, LkRecipientDetails: {} };
    case ActionTypes.LK_RECIPIENT_DETAILS_SUCCESS:
      return {
        ...state,
        LkRecipientDetails: { ...action.response },
        loading: false,
      };
    case ActionTypes.LK_RECIPIENT_DETAILS_FAIL:
      return {
        ...state,
        LkRecipientDetails: {},
        loading: false,
      };
    case ActionTypes.EDIT_LK_RECIPIENT:
      return { ...state, postingResult: {}, loading: true };
    case ActionTypes.EDIT_LK_RECIPIENT_SUCCESS:
      return {
        ...state,
        postingResult: { ...action.response },
        loading: false,
      };
    case ActionTypes.EDIT_LK_RECIPIENT_FAIL:
      return {
        ...state,
        postingResult: {},
        loading: false,
      };

    default: {
      return state;
    }
  }
};

export default LkRecipient;
